import Image from 'next/image';
import { useRouter } from 'next/router';
import Button from '@/components/Button';

type Props = {
  referrer_email: string;
  name: string;
  referrer_name: string;
  job: string;
};

export default function SuccessSubmittedReferral({
  referrer_name,
  referrer_email,
  job,
  name,
}: Props) {
  const router = useRouter();
  const displayReferrer = referrer_name ? referrer_name : referrer_email;

  return (
    <div className="min-h-content w-full">
      <article className="shadow-depth4 desktop:p-16 min-h-content relative flex w-full flex-col items-center justify-center overflow-hidden rounded-2xl bg-white p-8 text-left">
        <div className="relative mx-auto flex h-28 w-28">
          <Image
            src="/static/icons/customer/SendForm.svg"
            fill
            alt="Đã gửi thành công"
          />
        </div>
        <div className="mt-6">
          <h3 className="text-title32 text-neutral-80 text-center font-bold">
            Giới thiệu thành công
          </h3>
          <div className="mt-4">
            <p className="text-body16 text-left font-medium text-black">
              Chào <strong>{displayReferrer}</strong>, <br />
              Chúng tôi trân trọng sự giới thiệu/ chia sẻ thông tin vị trí
              Ahamove đang tuyển dụng <strong>{job}</strong>
              <br />
              Bộ phận HR của Ahamove sẽ bắt đầu quá trình đánh giá kỹ lưỡng về
              thông tin của <strong>{name}</strong> mà Bạn giới thiệu. Chúng tôi
              sẽ chủ động liên hệ với <strong>{name}</strong> nếu hồ sơ phù hợp
              với yêu cầu của vị trí này.
              <br />
              <br />
              Chúng tôi luôn đánh giá cao sự hỗ trợ của những người giới thiệu
              và mong muốn có cơ hội được hỗ trợ trong những vị trí sắp tới.{' '}
              <br />
              <br />
              Chân thành cảm ơn sự hỗ trợ của Bạn,
            </p>
          </div>
        </div>
        <Button
          title="Quay về trang chủ"
          className="mt-9 px-5"
          type="button"
          onClick={() => router.push('/')}
        >
          Quay về trang chủ
        </Button>
      </article>
    </div>
  );
}
